<template>
    <div class="schedules">

        <!-- Show schedules and sign in button-->
        <div class="sign-in" v-if="schedules.length">

            <p class="text-muted" v-if="course.driver == 'onsite'">Select the date and location to attend your class.</p>
            <p class="text-muted" v-if="course.driver == 'webinar'">Select the date to join the class.</p>

            <!-- List of Available Schedules-->
            <ul class="list-group mb-3">

                <li class="list-group-item" v-for="schedule in sortSchedules" :key="schedule.id">
                    <label :for="`radio-${schedule.id}`" class="mb-0 clickleable">
                        <input :id="`radio-${schedule.id}`" v-model="schedule_id" type="radio" name="option" :value="schedule.id" @change="updateValue(schedule.id)">
                        <div>
                            <h4 v-text="shortDateTime(schedule.date)"></h4>
                            <div class="text-muted mt-1" v-if="course.is_onsite" v-text="schedule.full_address"></div>
                        </div>
                    </label>
                </li>

                <li class="list-group-item">
                    <label for="radio-unscheduled" class="mb-0 clickleable">
                        <input id="radio-unscheduled" v-model="schedule_id" type="radio" name="option" :value="null" @change="updateValue(null)">
                        I will schedule later
                    </label>
                </li>

            </ul>
        </div>
        
        <div v-if="schedules.length == 0 && hasWaitingList" class="alert alert-info py-3">
            Currently, we don’t have a date for this class. Make your payment today and you will be added to our waitlist!
            <br>
            On the waitlist, you will receive priority for the next available class!
        </div>

        <!--  If there are not avilable schedules-->
        <div v-if="schedules.length == 0 && !hasWaitingList" class="text-danger d-flex">
            We don't have coming schedule dates for this course at this moment.
            <course-notify-me-avilable :course="course"></course-notify-me-avilable>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            value:{
                require: true,
            },
            course: {
                type: Object,
                required: true
            },
            schedules: {
                type: Array,
                required: true,
            }
        },

        data(){
            return {
                schedule_id: this.value,
                notifyMeForm: new Form({ email: ''}),
            }
        },

        methods: {

            updateValue(id){
                this.$emit('input', id)
            },

            notifyMe() {
                App.request().post(`courses/${this.course.slug}/notify-me`);
            },

        },

        computed:{
            sortSchedules(){
                return _.sortBy(this.schedules, schedule => {
                    return schedule.date;
                })
            },

            hasWaitingList(){
                return this.course.has_waiting_list;
            }
        }
    }
</script>